export default __webpack_public_path__ + "static/pattern-img-1-7ed89e86b84a4ee6586217f4b7f2197d.png";